import { PropsWithChildren, ReactNode } from 'react';

export const Legend = (props: PropsWithChildren<{}>) => {
  return <div className="flex space-x-6 divide-x divide-slate-700">{props.children}</div>;
};

export const LegendItem = ({
  value,
  label,
  align,
  color,
}: {
  value: string;
  label: ReactNode;
  align: 'center' | 'left';
  color: string;
}) => {
  return (
    <div className="flex flex-col items-end even:pl-6">
      <div className={`flex items-center`}>
        <div className={`rounded-full w-2 h-2 ${color} mr-2`}></div>
        <span className="text-sm font-medium text-white font-mono">{value}</span>
      </div>
      <span className="text-xs font-mono text-shale-200 whitespace-nowrap">{label}</span>
    </div>
  );
};
